export class UomMaster {
}
